import React from "react";
import {
  IconButton,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { MoreVertOutlined } from "@material-ui/icons";
import { ReportExecutionOrder } from "../../../types/ReportExecutionOrder";

const ReportDefinitionItem = ({
  procedureDefinitionItem,
  onClickEditItem,
  onClickDeleteItem,
}: {
  procedureDefinitionItem: ReportExecutionOrder;
  onClickEditItem: (procedureDefinitionItem: ReportExecutionOrder) => void;
  onClickDeleteItem: (procedureDefinitionItem: ReportExecutionOrder) => void;
}) => {
  const [anchorElement, setAnchorElement] = React.useState<HTMLElement | null>(
    null
  );

  const handleOpenItemOptionsClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorElement(event.currentTarget);
  };

  const handleCloseItemOptions = () => {
    setAnchorElement(null);
  };

  return (
    <ListItem
      key={`${procedureDefinitionItem.execution_group_number}-${procedureDefinitionItem.execution_group_name}-${procedureDefinitionItem.product_definition_id}`}
    >
      <ListItemText
        primary={`(${procedureDefinitionItem.execution_group_number}) ${procedureDefinitionItem.execution_group_name}`}
        secondary={
          <>
            {/* <p>
              Report Definition:{" "}
              {procedureDefinitionItem.procedure_definition_name}
            </p> */}
            <p>
              Report Definition:{" "}
              {procedureDefinitionItem.procedure_definition_name}
            </p>
            <p>
              Report order number:{" "}
              {procedureDefinitionItem.execution_group_number}
            </p>
            
          </>
        }
      />
      <ListItemSecondaryAction>
        <IconButton
          edge="end"
          onClick={(event) => {
            handleOpenItemOptionsClick(event);
          }}
        >
          <MoreVertOutlined />
        </IconButton>
        <Menu
          id={`menu-${procedureDefinitionItem.product_definition_id}`}
          open={Boolean(anchorElement)}
          anchorEl={anchorElement}
          keepMounted
          onClose={handleCloseItemOptions}
        >
          <MenuItem
            onClick={() => {
              handleCloseItemOptions();
              onClickEditItem(procedureDefinitionItem);
            }}
          >
            Edit
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseItemOptions();
              onClickDeleteItem(procedureDefinitionItem);
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default ReportDefinitionItem;
